export const MeasureHeight = {
  mounted() {
    const wrapper = this.el
    const iframe = wrapper.querySelector("iframe")
    const expandCollapseToggle = document.querySelector(
      `#expand-collapse-toggle-activity-feed-item-${wrapper.id.split("-").pop()}`,
    )

    if (!iframe) {
      console.warn("No iframe found inside the element.")
      return
    }

    const updateToggleVisibility = () => {
      try {
        const iframeDocument = iframe.contentWindow?.document
        if (!iframeDocument) {
          console.warn(
            "Unable to access iframe document. Check cross-origin restrictions.",
          )
          return
        }

        const iframeHeight = iframeDocument.body.scrollHeight
        const shouldShow = iframeHeight > 200

        if (shouldShow) {
          expandCollapseToggle.classList.remove("hidden")
        } else {
          expandCollapseToggle.classList.add("hidden")
        }
      } catch (error) {
        console.error("Error accessing iframe content:", error)
      }
    }

    // Observe size changes using ResizeObserver
    const resizeObserver = new ResizeObserver(() => {
      updateToggleVisibility()
    })

    resizeObserver.observe(iframe)

    // Observe when the wrapper element comes into view using IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Element is back in view, re-evaluate visibility
          updateToggleVisibility()
        }
      })
    })

    intersectionObserver.observe(wrapper)

    // Cleanup observers on destroy
    this.destroy = () => {
      resizeObserver.disconnect()
      intersectionObserver.disconnect()
    }
  },

  destroyed() {
    this.destroy && this.destroy()
  },
}
